export type SalutationCode = 'MR' | 'MRS';

const mrValues = new Set([
  'mr',
  'mr.',
  'herr',
  'bay',
  'male',
  'm',
]);

const mrsValues = new Set([
  'mrs',
  'mrs.',
  'ms',
  'ms.',
  'frau',
  'bayan',
  'female',
  'f',
]);

export function normalizeSalutationCode(value: unknown): SalutationCode | null {
  const normalized = String(value ?? '').trim().toLowerCase();
  if (!normalized) return null;

  if (normalized === 'mr' || normalized === 'mrs') {
    return normalized.toUpperCase() as SalutationCode;
  }
  if (mrValues.has(normalized)) return 'MR';
  if (mrsValues.has(normalized)) return 'MRS';
  return null;
}
